module.exports = __webpack_public_path__ + "img/ItsMe.777f1996.jpg";